<template>
    <div id="transmission-filter-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Filter Sent Items</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="message" class="alert alert-danger" role="alert">{{ message }}</div>
                    <div class="container">
                        <div class="row">
                            <div class="col-sm">
                                <label for="statusFilter" class="my-auto">Status</label>
                            </div>
                            <div class="col-sm">
                                <select id="statusFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : selectedFilters.transmission_status_code === null }]" v-model="selectedFilters.transmission_status_code">
                                    <option :value="null">Any</option>
                                    <option v-for="option in statusOptions" :key="'status-' + option.code" :value="option.code" v-text="option.name"></option>
                                </select>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-sm">
                                <label for="typeFilter" class="my-auto">Document Type</label>
                            </div>
                            <div class="col-sm">
                                <select id="typeFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : selectedFilters.document_type_id === null }]" v-model="selectedFilters.document_type_id">
                                    <option :value="null">Any</option>
                                    <option v-for="option in typeOptions" :key="'type-' + option.id" :value="option.id" v-text="option.name"></option>
                                </select>
                            </div>                                                        
                        </div>
                        <div class="row my-2">
                            <div class="col-sm">
                                <label for="methodFilter" class="my-auto">Transmission Method</label>
                            </div>
                            <div class="col-sm">
                                <select id="methodFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : selectedFilters.transmission_method_id === null }]" v-model="selectedFilters.transmission_method_id">
                                    <option :value="null">Any</option>
                                    <option v-for="option in methodOptions" :key="'method-' + option.id" :value="option.id" v-text="option.name"></option>
                                </select>
                            </div>                                                        
                        </div>                        
                        <div class="row my-2">
                            <div class="col-sm">
                                <label for="initiatorFilter" class="my-auto">Initiated By</label>
                            </div>
                            <div class="col-sm">
                                <select id="initiatorFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : selectedFilters.initiated_by === null }]" v-model="selectedFilters.initiated_by">
                                    <option :value="null">Any</option>
                                    <option v-for="option in initiatorOptions" :key="'owner-' + option.id" :value="option.id" v-text="option.last_name"></option>
                                </select>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mt-3 mb-1">
                            <label class="d-inline-flex my-auto">Initiated Date Range</label>
                            <div class="d-inline-flex align-items-center">
                                <input type="date" class="form-control form-control-sm" v-model="selectedFilters.initiated_at.begin">
                                <span class="mx-1">To</span>
                                <input type="date" class="form-control form-control-sm" v-model="selectedFilters.initiated_at.end">
                            </div>                                
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <a href="javascript:void(0)" class="mr-auto" @click="reset">Reset Filters</a>
                    <button type="button" class="btn btn-primary" @click="done">Done</button>
                </div>
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    data() {
        return {
            statusOptions: [],
            typeOptions: [],
            methodOptions: [],
            initiatorOptions: [],            
            selectedFilters: {
                transmission_status_code: null,
                document_type_id: null,
                transmission_method_id: null,
                initiated_by: null,
                initiated_at: {
                    begin: null,
                    end: null
                }
            },
            message: null  
        }
    },
    methods: {
        show: function (statusOptions, typeOptions, methodOptions, initiatorOptions, filters) {

            this.statusOptions = statusOptions;
            this.typeOptions = typeOptions;
            this.methodOptions = methodOptions;
            this.initiatorOptions = initiatorOptions;

            this.selectedFilters = JSON.parse(JSON.stringify(filters));
            this.message = null;

            $('#transmission-filter-modal').modal('show');
        },
        reset: function () {
            this.selectedFilters = {
                transmission_status_code: null,
                document_type_id: null,
                transmission_method_id: null,
                initiated_by: null,
                initiated_at: {
                    begin: null,
                    end: null
                }
            };
        },
        done: function () {
            this.$emit('filter', this.selectedFilters);
            $('#transmission-filter-modal').modal('hide');
        }
    },
    created() {
        eventHub.$on('show-transmission-filters', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-transmission-filters');
    },
    watch: {
        'selectedFilters.initiated_at.begin': function (newValue, oldValue) {
            if (newValue != oldValue) {
                this.selectedFilters.initiated_at.end = newValue;
            }
        }
    }      
}
</script>

<style scoped>

</style>